// extracted by mini-css-extract-plugin
export default {"container":"fk-z","freeShip":"gk-z","privacy":"hk-z"};